/*
|--------------------------------------------------------------------------
| Beginning Balance Dummy Data
|--------------------------------------------------------------------------
| Temporary data for UI Development
|--------------------------------------------------------------------------
*/

// ==============================
// SUMMARY
// ==============================

export const summaryData = {
    total_batch: 125,
    total_rack: 18,
    total_box: 3240,
    total_qty: 156800,
    posted_percent: 76,
};

// ==============================
// PROGRESS
// ==============================

export const progressData = {
    total: 125,
    draft: 22,
    posted: 95,
    cancelled: 8,
};

// ==============================
// WAREHOUSE
// ==============================

export const warehouseList = [
    {
        id: 1,
        code: "WH001",
        name: "Raw Material Warehouse",
    },
    {
        id: 2,
        code: "WH002",
        name: "Finished Goods Warehouse",
    },
    {
        id: 3,
        code: "WH003",
        name: "Packaging Warehouse",
    },
];

// ==============================
// RACK
// ==============================

export const rackList = [
    { id: 1, code: "R001" },
    { id: 2, code: "R002" },
    { id: 3, code: "R003" },
    { id: 4, code: "R004" },
    { id: 5, code: "R005" },
    { id: 6, code: "R006" },
    { id: 7, code: "R007" },
];

// ==============================
// RECENT ACTIVITY
// ==============================

export const activityData = [
    {
        id: 1,
        type: "CREATE",
        title: "Beginning Balance Created",
        description: "Beginning Balance BB20260715001 berhasil dibuat.",
        user: "Administrator",
        batch: "BB20260715001",
        time: "09:10",
    },
    {
        id: 2,
        type: "UPDATE",
        title: "Beginning Balance Updated",
        description: "Perubahan quantity dan rack.",
        user: "Warehouse Admin",
        batch: "BB20260715002",
        time: "08:45",
    },
    {
        id: 3,
        type: "POSTING",
        title: "Posting Success",
        description: "Beginning Balance berhasil diposting.",
        user: "Supervisor",
        batch: "BB20260715003",
        time: "08:05",
    },
    {
        id: 4,
        type: "DELETE",
        title: "Beginning Balance Deleted",
        description: "Data Beginning Balance dihapus.",
        user: "Administrator",
        batch: "BB20260714008",
        time: "Yesterday",
    },
];

// ==============================
// TABLE
// ==============================

export const beginningBalanceList = [
    {
        id: 1,
        batch_number: "BB20260715001",
        warehouse_id: 1,
        warehouse: "Raw Material Warehouse",
        rack_code: "R001",
        total_box: 250,
        total_qty: 15200,
        status: "Draft",
        created_by: "Administrator",
        created_at: "15 Jul 2026 09:15",
    },
    {
        id: 2,
        batch_number: "BB20260715002",
        warehouse_id: 2,
        warehouse: "Finished Goods Warehouse",
        rack_code: "R002",
        total_box: 180,
        total_qty: 9800,
        status: "Posted",
        created_by: "Administrator",
        created_at: "15 Jul 2026 08:40",
    },
    {
        id: 3,
        batch_number: "BB20260715003",
        warehouse_id: 3,
        warehouse: "Packaging Warehouse",
        rack_code: "R003",
        total_box: 320,
        total_qty: 24500,
        status: "Draft",
        created_by: "Warehouse Admin",
        created_at: "15 Jul 2026 08:10",
    },
    {
        id: 4,
        batch_number: "BB20260715004",
        warehouse_id: 1,
        warehouse: "Raw Material Warehouse",
        rack_code: "R004",
        total_box: 120,
        total_qty: 5500,
        status: "Cancelled",
        created_by: "Supervisor",
        created_at: "14 Jul 2026 16:30",
    },
    {
        id: 5,
        batch_number: "BB20260715005",
        warehouse_id: 2,
        warehouse: "Finished Goods Warehouse",
        rack_code: "R005",
        total_box: 500,
        total_qty: 38000,
        status: "Posted",
        created_by: "Administrator",
        created_at: "14 Jul 2026 14:00",
    },
    {
        id: 6,
        batch_number: "BB20260715006",
        warehouse_id: 1,
        warehouse: "Raw Material Warehouse",
        rack_code: "R006",
        total_box: 145,
        total_qty: 8600,
        status: "Draft",
        created_by: "Warehouse Admin",
        created_at: "13 Jul 2026 10:15",
    },
    {
        id: 7,
        batch_number: "BB20260715007",
        warehouse_id: 3,
        warehouse: "Packaging Warehouse",
        rack_code: "R007",
        total_box: 275,
        total_qty: 16750,
        status: "Posted",
        created_by: "Supervisor",
        created_at: "13 Jul 2026 08:45",
    },
];